import { createContext } from "react";
import { find } from "lodash";
import scrollToElement from "@Src/utils/scrollToElement";
export const DealsContext = createContext();

export const REDEMPTION_TYPES = {
  PRINT: "instore_print",
  SHOW: "instore",
  ONLINE: "link",
  CALL: "call",
};

export const DEAL_STEP = {
  FIRST: "picking from locations",
  SECOND: "reviewing details",
  THIRD: "showing deal",
};

export const FLYOUT_SCREENS = {
  // screen 1 options
  LOCATION_DEALS: "LOCATION SCREEN: deals",
  // screen 2 options
  DETAILS_DEAL: "DETAILS SCREEN: deal",
  // screen 3 options
  SHOW_PRINT_PREVIEW: "SHOW SCREEN: coupon pint preview",
  SHOW_COUPON: "SHOW SCREEN: coupon",
  SHOW_LINK: "SHOW SCREEN: link to deal",
  SHOW_PHONE: "SHOW SCREEN: phone number and related data",
};

export const initialDealsContext = {
  store: {}, // current store to parse in flyout
  currentOffer: {}, // current offer of a shown in details and show screens
  selectedLocation: {}, // current location user is viewing offers for
  redeemedLimitedOffer: false, // if user redeems a limited use coupon, use this to re-fetch the store info
  member: {}, // the user/member redeeming the deal
  currentFlyoutScreen: FLYOUT_SCREENS.LOCATION_DEALS, // current screen to show in flyout
  currentStep: DEAL_STEP.FIRST,
  isMapHidden: true,
  hasRedeemError: false,
};

export function getCurrentScreen(step) {
  if (step === DEAL_STEP.FIRST) {
    return FLYOUT_SCREENS.LOCATION_DEALS;
  } else if (step === DEAL_STEP.SECOND) {
    return FLYOUT_SCREENS.DETAILS_DEAL;
  }
}

export function getRedemptionTypes(offer) {
  const types = [];
  const { links, product_group } = offer;
  if (!links || !links.redeem_offer) return types;
  if (links.redeem_offer.instore) {
    types.push(REDEMPTION_TYPES.SHOW);
  }
  if (links.redeem_offer.instore_print) {
    types.push(REDEMPTION_TYPES.PRINT);
  }
  if (product_group === null && links.redeem_offer.link) {
    types.push(REDEMPTION_TYPES.ONLINE);
  }
  if (links.redeem_offer.call) {
    types.push(REDEMPTION_TYPES.CALL);
  }
  return types;
}

export function getContextByState(state, setState) {
  return {
    ...state,
    setCurrentStore: (store) => {
      if (
        !!store &&
        !!store.closest_location &&
        !!state.selectedLocation &&
        !!state.selectedLocation.location_id
      ) {
        // if we get a new store, after the selected location is set - like in the case
        // of a user signing in, we need to update the selected location so it has the redeem info
        const currentLocationId = state.selectedLocation.location_id;
        const closestLocationId = store.closest_location.location_id;
        let location =
          closestLocationId === currentLocationId
            ? store.closest_location
            : find(store.locations, (l) => {
                return l.location_id === currentLocationId;
              });
        if (!location) {
          location = store.closest_location;
        }
        setState({ ...state, store, selectedLocation: location });
      } else {
        setState({ ...state, store, selectedLocation: store.closest_location });
      }
    },
    setIsMapHidden: (isMapHidden) => {
      setState({ ...state, isMapHidden });
    },
    setSelectedLocation: (selectedLocation) => {
      // this is only for the new offer modal layout/flow - can be removed if not chosen to use after a/b test
      setState({ ...state, selectedLocation });
    },
    setRedeemedLimitedOffer: (value) => {
      // this is only for the new offer modal layout/flow - can be removed if not chosen to use after a/b test
      setState({ ...state, redeemedLimitedOffer: value });
    },
    setNextStepAndScreen: (step, screen) => {
      setState({
        ...state,
        currentStep: step,
        currentFlyoutScreen: screen,
      });
    },
    selectAnOffer: (offer, doNotChangeScreen = false) => {
      setState({
        ...state,
        currentFlyoutScreen: doNotChangeScreen
          ? state.currentFlyoutScreen
          : FLYOUT_SCREENS.DETAILS_DEAL,
        currentStep: doNotChangeScreen ? state.currentStep : DEAL_STEP.SECOND,
        currentOffer: offer,
      });
    },
    setHasRedeemError: (hasError) => {
      setState({
        ...state,
        hasRedeemError: hasError,
      });
    },
    handleGoBack: (closeModalCallback) => {
      if (state.currentStep === DEAL_STEP.FIRST) {
        closeModalCallback();
        return setState({
          ...state,
          currentOffer: {},
          selectedLocation: {},
          store: {},
          hasRedeemError: false,
        });
      }
      const nextStep = getNextBackStep(state.currentStep);
      const nextScreen = getCurrentScreen(nextStep);
      setState({
        ...state,
        currentStep: nextStep,
        currentFlyoutScreen: nextScreen,
        currentOffer: {},
        hasRedeemError: false,
      });
    },
  };
}

export function scrollToTopOfDealsModal() {
  const containerEl = document.querySelector(".offer-details-modal .ModalContainer--content");

  scrollToElement(containerEl, 0, 400);
}

function getNextBackStep() {
  return DEAL_STEP.FIRST;
}
